document.addEventListener("change", async (e) => {
      const select = e.target.closest('select[name="id"]');
      if (!select) return;

      const cardInfo = select.closest("product-info");
      if (!cardInfo) return;

      const sectionId = cardInfo.dataset.sectionInput;
      const sectionCombined = cardInfo.dataset.section;
      const productId = sectionCombined.replace(sectionId + "-", "");
      const baseUrl = cardInfo.dataset.url;

      const variantId = select.value;
      const viewUrl = `${baseUrl}?view=variant-json&id=${variantId}`;

      let variantData = null; 

      try {
        const res = await fetch(viewUrl);
        variantData = await res.json();
      } catch (err) {
        console.warn("Variant JSON missing", err);
        return;
      }

      const wrapper = document.querySelector(
        `#webipro-${sectionId}-${productId}`
      );
      if (!wrapper) return;

      wrapper.querySelectorAll(".product__media-item").forEach(el => {
        el.style.display = "none";
      });

      
      if (variantData.featured_media?.id) {
        wrapper.querySelectorAll(
          `[data-media-id$="-${variantData.featured_media.id}"]`
        ).forEach(el => el.style.display = "block");
      }

      if (
        variantData.metafields &&
        variantData.metafields.theme &&
        variantData.metafields.theme.gang_media &&
        variantData.metafields.theme.gang_media.length > 0
      ) {
        variantData.metafields.theme.gang_media.forEach(id => {
          wrapper.querySelectorAll(
            `[data-media-id$="-${id}"]`
          ).forEach(el => el.style.display = "block");
        });
      }

      const firstVisible = wrapper.querySelector('.product__media-item[style*="block"]');
      if (firstVisible) wrapper.prepend(firstVisible);
    });